// Contenido editable del sitio de Alfredj

export const SESSIONS = [
  {
    id: 'indie-dance',
    label: 'Indie-Dance',
    title: 'Indie-Dance para Festivales',
    desc: 'Energía máxima. Guitarras, sintetizadores y bombo cuatro por cuatro para no parar de bailar.',
    // Reemplaza esta URL por tu track/set real de SoundCloud
    url: 'https://soundcloud.com/two-door-cinema-club/something-good-can-work',
  },
  {
    id: 'tardeo',
    label: 'Tardeo Alternativo',
    title: 'Tardeo Alternativo',
    desc: 'Sesión de tarde. Indie-pop luminoso, mid-tempo y buen rollo para calentar la pista.',
    url: 'https://soundcloud.com/glassanimals/heat-waves',
  },
  {
    id: 'britpop',
    label: 'Clásicos del Britpop',
    title: 'Clásicos del Britpop',
    desc: 'Oasis, Blur, Pulp y compañía. El sonido que marcó a una generación, sin filtros.',
    url: 'https://soundcloud.com/arcticmonkeys/do-i-wanna-know',
  },
];

export const SERVICES = [
  {
    id: 'festivales',
    tag: '01',
    title: 'Festivales y Clubes',
    desc: 'Sesiones enérgicas y de vanguardia pensadas para mantener la pista llena hasta el final. Selección exigente, lectura de la sala y transiciones que no dan respiro.',
    span: 'md:col-span-8',
    image:
      'https://customer-assets.emergentagent.com/job_dj-alfredj/artifacts/t6sizn0x_alfredj3.webp',
  },
  {
    id: 'corporativos',
    tag: '02',
    title: 'Eventos Corporativos',
    desc: 'Branding a través de la música con un toque cool. Ambiente cuidado que refuerza la identidad de tu marca sin caer en lo genérico.',
    span: 'md:col-span-4',
    image:
      'https://customer-assets.emergentagent.com/job_dj-alfredj/artifacts/sdfo9vqi_alfredj5.webp',
  },
];

export const TESTIMONIALS = [
  {
    quote:
      'Nos clavó el ambiente de la tarde de principio a fin. Indie del bueno, sin bajones, y el público entregadísimo.',
    author: 'Tardeo Alternativo',
    role: 'Organización · Albacete',
  },
  {
    quote:
      'Un selector de los de verdad. Sabe leer la sala y llevarte donde quiere. Repetiremos seguro en la próxima temporada.',
    author: 'Sala Clandestino',
    role: 'Programación de conciertos',
  },
  {
    quote:
      'Profesional, puntual y con un criterio musical brutal. Convirtió nuestro evento de marca en algo que la gente recuerda.',
    author: 'Laura Ruiz',
    role: 'Directora de eventos',
  },
];

export const BRANDS = [
  'SALA CLANDESTINO',
  'FESTIVAL INDIEBLANCA',
  'TARDEO ALBACETE',
  'CLUB SUBSUELO',
  'RUIDO FEST',
  'LA CHISPA',
];

export const NAV_LINKS = [
  { label: 'Alfredj', href: '#sobre' },
  { label: 'Sesiones', href: '#sesiones' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Galería', href: '#galeria' },
  { label: 'Eventos', href: '#eventos' },
  { label: 'Contacto', href: '#contacto' },
];

export const INSTAGRAM_URL = 'https://www.instagram.com/alfre_ddjay/';
export const INSTAGRAM_HANDLE = 'alfre_ddjay';
export const INSTAGRAM_DM_URL = 'https://ig.me/m/alfre_ddjay';

const A = 'https://customer-assets.emergentagent.com/job_dj-alfredj/artifacts';
export const GALLERY = [
  { src: `${A}/qq8lwpdu_alfredj1.webp`, alt: 'Alfredj con el brazo en alto en el festival' },
  { src: `${A}/t6sizn0x_alfredj3.webp`, alt: 'Alfredj en escenario con pantallas y público' },
  { src: `${A}/znwitu10_alfredj2.webp`, alt: 'Retrato de Alfredj con auriculares' },
  { src: `${A}/sdfo9vqi_alfredj5.webp`, alt: 'Vista desde la cabina hacia el público' },
  { src: `${A}/qj2sku4c_alfredj4.jpeg`, alt: 'Cabina naranja con el logo ALFRE DJAY' },
];
